export const onRefreshUnreadCount = {
  /**
   * The sidebar navigation component will handle this function invocation by fetching
   * the current unread notification count from the server and updating the UI accordingly.
   *
   * This would not be expected to be used from any action within the sidebar itself rather
   * from other applications which may make their own mutations to the notification read/unread
   * state via API calls and need a way to refresh the count displayed in the nav bar bell icon.
   */
  onRefreshUnreadCount: {
    args: {}
  }
};